import React, { useLayoutEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

export const THEME_KEY = 'talit-appearance';
export function readTheme() {
  try { return window.localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'; }
  catch { return 'light'; }
}

// Browser preference, deliberately independent of hotel configuration. Storage
// can be disabled on shared/private devices; the toggle still works in memory.
export default function ThemeToggle() {
  const [theme, setTheme] = useState(readTheme);
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;
    return () => { delete document.documentElement.dataset.theme; };
  }, [theme]);
  useLayoutEffect(() => {
    const sync = (event) => {
      if (event.key === THEME_KEY || event.key === null) setTheme(readTheme());
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    try { window.localStorage.setItem(THEME_KEY, next); } catch { /* In-memory preference. */ }
  };
  const label = `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`;
  return (
    <button type="button" onClick={toggle} aria-label={label}
      aria-pressed={theme === 'dark'} title={label}
      className="no-print flex flex-shrink-0 items-center justify-center gap-1 rounded w-10 h-10 text-shell-text hover:bg-shell-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
      {theme === 'dark' ? <Sun className="w-5 h-5" aria-hidden="true" /> : <Moon className="w-5 h-5" aria-hidden="true" />}
    </button>
  );
}
